import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActivityTypeEnum } from '@sport-activities/sdk';

import { AbstractActivityPages } from '~/attendee/components/pages/activity-detail/classes/abstract-activity-pages';
import { Logger } from '~/core/logger.service';
import { Activity } from '~/core/model/activity.model';
import { CustomHeadTagService } from '~/core/services/custom-head-tag/custom-head-tag.service';
import { OpenGraphService } from '~/core/services/open-graph/open-graph.service';
import { RedirectionService } from '~/core/services/redirection/redirection.service';
import { RouterHistoryService } from '~/core/services/router-history/router-history.service';
import { SportsService } from '~/core/services/sports/sports.service';
import { TitleService } from '~/core/services/title/title.service';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';
import { ToggleService } from '~/toggles/services/toggle.service';
@Component({
  selector: 'app-attendee-activity-dates',
  templateUrl: './activity-dates.component.html',
})
export class AttendeeActivityDatesComponent extends AbstractActivityPages {
  constructor(
    public readonly activatedRoute: ActivatedRoute,
    public readonly titleService: TitleService,
    public readonly routerHistory: RouterHistoryService,
    public readonly openGraphService: OpenGraphService,
    public readonly sportsService: SportsService,
    public readonly redirectionService: RedirectionService,
    public readonly toggleService: ToggleService,
    public readonly customHeadTag: CustomHeadTagService,
    public readonly organizerSharedActivityService: OrganizerSharedActivityService,
    public readonly logger: Logger
  ) {
    super(
      activatedRoute,
      titleService,
      routerHistory,
      openGraphService,
      sportsService,
      redirectionService,
      toggleService,
      customHeadTag,
      organizerSharedActivityService,
      logger
    );
  }

  public handleRedirections(
    activityDetailData: { [key: string]: Activity },
    path: string
  ): void {
    // redirect to 'live' url if needed
    const sku = activityDetailData?.activity?.sku;
    if (
      activityDetailData?.activity?.type === ('LIVE' as ActivityTypeEnum) &&
      path.includes('attendee.show-activity-dates')
    ) {
      this.redirectionService.redirect(
        `/${'attendee.show-live-activity-dates'}/${sku}`
      );
    }

    // redirect to details page if no timeslot
    if (!this.timeslots?.length) {
      this.redirectionService.redirect(
        `/${
          activityDetailData?.activity?.type === ('LIVE' as ActivityTypeEnum)
            ? 'attendee.show-live-activity'
            : 'attendee.show-activity'
        }/${sku}`
      );
    }
  }

  public setTitle(): void {
    this.titleService.setPageTitle('seo.attendee.activity_dates.title', {
      title: this.activity?.name,
    });
  }
}
